// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7064":"dd7b1813","9567":"e83191de","9921":"544c255b"}[chunkId] + ".chunk.css";
};